import React from 'react'

import { Box, GammaText } from '@factorialco/deprecated-design-system'

interface Props {
  text: string
  betweenKeys?: boolean
}

const Text = ({ text, betweenKeys = false }: Props) => {
  const boxStyle: React.ComponentProps<typeof Box> = betweenKeys
    ? { paddingX: 's6' }
    : { paddingLeft: 's6' }

  return (
    <Box {...boxStyle}>
      <GammaText.Normal size="100" weight="medium" color="grey700">
        {text}
      </GammaText.Normal>
    </Box>
  )
}

export default Text
